export enum AispActivationState {
  AuthURL = "Pending:Initialised:PendingAccept",
  AccountDetails = "Activated:Processed:NonePending",
  AccountCanceled = "Cancelled:Initialised:NonePending",
  AccountRejected = "Rejected",
}
